// Utils
import { isFeedbackOnlyAccess, isFullAccess } from '../permissions/permissionUtil';

export const convertPermissionValueToText = (permissionValue) => {
    if (isFullAccess(permissionValue)) return 'Edit';
    if (isFeedbackOnlyAccess(permissionValue)) return 'Feedback';
    return 'Read only';
};
